module.exports = __webpack_public_path__ + "static/media/17c-02_ST-2017-200x150cm-oleo-sobre-madera.7ab8f64c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/17c/17c-02_ST-2017-200x150cm-oleo-sobre-madera.jpg
// module id = 211
// module chunks = 0